import { Routes } from '@angular/router';

import { ThankYouComponent } from './thank-you/thank-you.component';
import { DonationAmountComponent } from './dynamic-section/donation-amount.component';
import { PaymentTypeComponent } from './dynamic-section/payment-type.component';
import { RecurringComponent } from './dynamic-section/recurring.component';
import { LoginComponent } from './user/login.component';
import { DoubleTheDonationComponent } from './dynamic-section/double-the-donation.component';
import { DesignationsComponent } from './dynamic-section/designations.component';
import { GiftComponent } from './dynamic-section/gift.component';
import { TributeComponent } from './dynamic-section/tribute.component';
import { BillingInfoComponent } from './dynamic-section/billing-info.component';
import { PaymentInfoComponent } from './dynamic-section/payment-info.component';
import { OptInsComponent } from './static-section/opt-ins.component';
import { GiveButtonComponent } from './static-section/give-button.component';
import { ImpactComponent } from './static-section/impact.component';
import { TestimonialComponent } from './static-section/testimonial.component';
import { CustomNotesComponent } from './dynamic-section/custom-notes.component';
import { FooterComponent } from './footer.component';

export class DynamicRouting {
  routes: Routes;
  constructor(routeMap, thankYouRouteMap) {
    // TODO : receive the child routes in this constructor, or build from config
    // the extra lookups into routeMap and thankYouRouteMap for individual form components,
    // being mixed with actual routing, is very gross.
    this.routes = [
      {
        path: 'thank-you',
        component: ThankYouComponent,
        children: [
          thankYouRouteMap.designations
            ? {
                path: '',
                component: DesignationsComponent,
                outlet: 'designations',
                data: { single: true }
              }
            : undefined,
          thankYouRouteMap.corporate_matching
            ? {
                path: '',
                component: DoubleTheDonationComponent,
                outlet: 'corporate'
              }
            : undefined,
          thankYouRouteMap.impact
            ? {
                path: '',
                component: ImpactComponent,
                outlet: 'impact'
              }
            : undefined,
          { path: '', component: FooterComponent, outlet: 'footer' }
        ].filter(removeUndefined)
      },
      {
        path: '',
        children: [
          routeMap.login
            ? {
                path: '',
                component: LoginComponent,
                outlet: 'login'
              }
            : undefined,
          routeMap.donation_amount
            ? {
                path: '',
                component: DonationAmountComponent,
                outlet: routeMap.donation_amount
              }
            : undefined,
          routeMap.payment_type
            ? {
                path: '',
                component: PaymentTypeComponent,
                outlet: routeMap.payment_type
              }
            : undefined,
          routeMap.recurring
            ? {
                path: '',
                component: RecurringComponent,
                outlet: routeMap.recurring
              }
            : undefined,
          routeMap.corporate_matching
            ? {
                path: '',
                component: DoubleTheDonationComponent,
                outlet: routeMap.corporate_matching
              }
            : undefined,
          routeMap.designations
            ? {
                path: '',
                component: DesignationsComponent,
                outlet: routeMap.designations
              }
            : undefined,
          routeMap.custom_notes
            ? {
                path: '',
                component: CustomNotesComponent,
                outlet: routeMap.custom_notes
              }
            : undefined,
          routeMap.gift
            ? {
                path: '',
                component: GiftComponent,
                outlet: routeMap.gift
              }
            : undefined,
          routeMap.tribute
            ? {
                path: '',
                component: TributeComponent,
                outlet: routeMap.tribute
              }
            : undefined,
          routeMap.billing_info
            ? {
                path: '',
                component: BillingInfoComponent,
                outlet: routeMap.billing_info
              }
            : undefined,
          routeMap.payment_info
            ? {
                path: '',
                component: PaymentInfoComponent,
                outlet: routeMap.payment_info
              }
            : undefined,
          { path: '', component: OptInsComponent, outlet: '10' },
          routeMap.impact
            ? {
                path: '',
                component: ImpactComponent,
                outlet: 'impact'
              }
            : undefined,
          { path: '', component: GiveButtonComponent, outlet: 'continue' },
          { path: '', component: FooterComponent, outlet: 'footer' },
          routeMap.testimonial
            ? {
                path: '',
                component: TestimonialComponent,
                outlet: 'testimonial'
              }
            : undefined
        ].filter(removeUndefined)
      },
      { path: '**', redirectTo: '' }
    ];
  }
  getRouteConfig() {
    return this.routes;
  }
}

function removeUndefined(x: any) {
  return x !== undefined;
}
